(function () {
  function init(block) {

  // Check if products storage has expired
  const productsExpiry = localStorage.getItem('productsExpiry');

  if (productsExpiry && Date.now() > Number(productsExpiry)) {
    localStorage.removeItem('products');
    localStorage.removeItem('productsExpiry');
  }


    /* Snippet can be rendered (and this script included) more than once per page */
    if (block.dataset.nmInit) return;
    block.dataset.nmInit = '1';

    var nmId         = block.dataset.nmBlock;
    var scriptUrl    = block.dataset.nmScriptUrl   || '';
    var productTitle = block.dataset.nmProduct     || '';
    var productUrl   = block.dataset.nmUrl         || '';
    var phonePrefix  = block.dataset.nmPrefix      || '+91';
    var popupBtnText = block.dataset.nmPopupBtn    || 'Notify Me';

    var notifVarint = block.dataset.varint;
    var notifId = block.dataset.id;
    var notifTitle = block.dataset.title;
    var notifUrl = block.dataset.url;

    var overlay    = document.getElementById('nm-overlay-'   + nmId);
    var formWrap   = document.getElementById('nm-form-wrap-' + nmId);
    var form       = document.getElementById('nm-form-'      + nmId);

    var emailErr   = document.getElementById('nm-email-err-' + nmId);
    var phoneInput = document.getElementById('nm-phone-'     + nmId);
    var submitBtn  = document.getElementById('nm-submit-'    + nmId);
    var notifyTitle = document.getElementById('nm-card-'+ nmId);
    var notifyBtn  = block.querySelector('button');
    var notifyBtnText = notifyBtn && (
      notifyBtn.querySelector('span:not([aria-hidden="true"])') || notifyBtn
    );
    var errEl      = document.getElementById('nm-err-'       + nmId);
    var tyEl       = document.getElementById('nm-ty-'        + nmId);
    var notifNum   = document.getElementById('nm-notif-num-' + nmId);
    var editBtn    = document.getElementById('nm-edit-btn-'  + nmId);
    var notifyBtns = block.querySelectorAll('[data-nm-open]');
    notifyBtns.forEach(function (btn) {
      btn.addEventListener('click', open);
    });

    /* Move overlay to <body> so position:fixed is not trapped by transformed parents (e.g. sticky ATC bar) */
    if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);

    function updateNotifyButton() {
      var products = JSON.parse(localStorage.getItem('products') || '[]');
        if (products.includes(productTitle)) {
          if (notifyBtnText) {
            notifyBtnText.textContent = 'Alert On';
          }
        }
    }
    updateNotifyButton();
    function open() {
      var customerPhone = '';
      if (typeof getCustomerPhone === 'function') {
        customerPhone = getCustomerPhone() || '';
      }
      const storedPhone = localStorage.getItem('phone');
      const phone = customerPhone || storedPhone;

      if (phone) {
          phoneInput.value = phone;
          localStorage.setItem('phone', phone);
          console.log('Phone:', phone);/*
          window.trackShopifyEvent('techit:notify_me', {
            notifyme: {
              phone: {{ phone | json }},
              product_title: {{ productTitle | json }},
              product_url: {{ productUrl | json }}
            }
          }); */
          form.requestSubmit();
          showThanks();
        } 
      else{
      overlay && overlay.classList.add('nm-open');
      document.body.style.overflow = 'hidden';
      }
    }

    function close() {
      overlay && overlay.classList.remove('nm-open');
      document.body.style.overflow = '';
    }

    function showThanks() {
      formWrap.classList.add('nm-hidden');
      tyEl.classList.add('nm-show');
      submitBtn.disabled = false;
      submitBtn.textContent = popupBtnText;
      if (notifyBtnText) notifyBtnText.textContent = 'Alert On';
    }

    function resetSheet() {
      tyEl && tyEl.classList.remove('nm-show');
      formWrap && formWrap.classList.remove('nm-hidden');
      form && form.reset();
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = popupBtnText;
      }
      errEl && errEl.classList.remove('nm-show');
      emailErr && emailErr.classList.remove('nm-show');
    }

    window['nmOosClose' + nmId] = close;

    overlay && overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('nm-open')) close();
    });

    editBtn && editBtn.addEventListener('click', function () {
      tyEl.classList.remove('nm-show');
      formWrap.classList.remove('nm-hidden');
      phoneInput && phoneInput.focus();
    });

    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = phoneInput ? phoneInput.value.trim() : '';
        // BLOCK EMPTY OR INVALID PHONE
        if (!phone || !/^\d{10}$/.test(phone)) {
          if (errEl) errEl.classList.add('nm-show');
          if (phoneInput) phoneInput.focus();

          console.log('Invalid phone - submission stopped');
          return;
        }
      errEl && errEl.classList.remove('nm-show');

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
      notifyOnWhatsApp(phone, notifVarint, notifId, notifTitle, notifUrl);

      let currentArray = JSON.parse(localStorage.getItem('products') || '[]');

      //adding phone to local storage
      if (phone){
        localStorage.setItem("phone", phone);
      }
      if (!currentArray.includes(productTitle)) {
        currentArray.push(productTitle);
      }
      localStorage.setItem('products', JSON.stringify(currentArray));

      // Expire after 3 days
        localStorage.setItem(
          'productsExpiry',
          Date.now() + (3 * 24 * 60 * 60 * 1000)
        );
      const Products = localStorage.getItem('products');

      var displayPhone = phone ? (phonePrefix + ' ' + phone) : '';
      if (notifNum) notifNum.textContent = displayPhone || phonePrefix;

      if (!scriptUrl) { showThanks(); return; }

      var now = new Date();
      var formattedTimestamp = now.toLocaleDateString('en-GB') + ' ' + now.toLocaleTimeString('en-IN', { hour12: false });

      var params = new URLSearchParams({
        timestamp: formattedTimestamp,
        phone: phone,
        product: productTitle,
        url: productUrl
      });

      fetch(scriptUrl + '?' + params, { method: 'GET', mode: 'no-cors' })
        .then(showThanks).catch(showThanks);
    });

    overlay && overlay.addEventListener('transitionend', function () {
      if (!overlay.classList.contains('nm-open')) setTimeout(resetSheet, 300);
    });
  }

 document.querySelectorAll('[data-nm-block]').forEach(init);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        // If the added element itself is a notify block
        if (node.matches('[data-nm-block]')) {
          init(node);
        }

        // If notify blocks are inside the added element
        node.querySelectorAll &&
          node.querySelectorAll('[data-nm-block]').forEach(init);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (window.__nmOosGlobalBound) return;
  window.__nmOosGlobalBound = true;

  function findVariant(id) {
    var list = window.productData && window.productData.variants;
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return list[i];
    }
    return null;
  }

  /* Swap notify/buy panels on variant change — single global listener */
  function applyVariant(v) {
    if (!v) return;
    var isOos = !v.available || !!document.querySelector('[data-nm-force-oos]');
    document.querySelectorAll('.nm-notify-panel').forEach(function (p) {
      p.classList.toggle('nm-panel-hidden', !isOos);
    });
    document.querySelectorAll('.nm-buy-panel').forEach(function (p) {
      p.classList.toggle('nm-panel-hidden', isOos);
    });
    if (!isOos) {
      document.querySelectorAll('[data-nm-overlay]').forEach(function (o) {
        o.classList.remove('nm-open');
      });
      document.body.style.overflow = '';
    }
  }

  document.addEventListener('variant:change', function (e) {
    applyVariant(e.detail && e.detail.variant);
  });

  /* Product form variant id input (main product) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id' || !t.closest('form[data-type="add-to-cart-form"]')) return;
    applyVariant(findVariant(t.value));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      if (v) applyVariant(findVariant(v.id) || v);
    });
  }
})();
// Gokwik 
function makeXhr(method, url, data,domain) {
   var xhttp = new XMLHttpRequest();
   xhttp.open(method, url, true);
   xhttp.setRequestHeader('Content-type', 'application/json');
   xhttp.setRequestHeader('x-shopify-shop-domain', domain);
   xhttp.onload = function () {
     var status = xhttp.status;
     var response = xhttp.response;
   };
   xhttp.send(data ? JSON.stringify(data) : null);
 }
 
function notifyOnWhatsApp(phone, notifVarint, notifId, notifTitle, notifUrl){
  let domain = window.location.hostname;
   if(phone){
     const data ={
       'phone' : '+91' +phone,
       'variant_id':notifVarint,
       'product_id':notifId,
       'product_title' : notifTitle,
       'variant_url' : notifUrl
     }
     console.log('Thanks for subscribing the WhatsApp notification');
     makeXhr('POST','https://iy08ni8pq5.execute-api.ap-south-1.amazonaws.com/api/notify/api',data,domain);
   }else{
     console.log('Please provide the phone number');
   }
}


//AKfycbw_qNxdBYd7ommlfYUIbclXW4t51jXeE07n7KyUYuCSlfi89KSyr_6AaFiYWN3LONbw

//https://script.google.com/macros/s/AKfycbw_qNxdBYd7ommlfYUIbclXW4t51jXeE07n7KyUYuCSlfi89KSyr_6AaFiYWN3LONbw/exec